<app-header-four></app-header-four>

<!--section class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Contact Us</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Contact Us</li>
            </ul>
        </div>
    </div>
</section>

<section class="contact-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-7 col-md-12">
                <div class="contact-form">
                    <h3>Drop Us A Line</h3>
                    <p>We're happy to answer any questions you have or provide you with an estimate. Just send us a message in the form below with any questions you may have.</p>

                    <form id="contactForm">
                        <div class="row">
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group">
                                    <label>Name <span>*</span></label>
                                    <input type="text" name="name" id="name" class="form-control" placeholder="Your name">
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-6">
                                <div class="form-group">
                                    <label>Email <span>*</span></label>
                                    <input type="email" name="email" id="email" class="form-control" placeholder="Your email address">
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <label>Phone Number <span>*</span></label>
                                    <input type="text" name="phone_number" id="phone_number" class="form-control" placeholder="Your phone number">
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <label>Your Message <span>*</span></label>
                                    <textarea name="message" id="message" cols="30" rows="5" class="form-control" placeholder="Write your message..."></textarea>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <button type="submit" class="default-btn"><i class='flaticon-plane'></i> Send Message</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="col-lg-5 col-md-12">
                <div class="contact-info">
                    <h3>Here to Help</h3>
                    <p>Have a question? You may find an answer in our <a href="faq.html">FAQs</a>. But you can also contact us.</p>

                    <ul class="contact-list">
                        <li><i class='bx bx-map'></i> Location: <a href="#">Wonder Street, USA, New York</a></li>
                        <li><i class='bx bx-phone-call'></i> Call Us: <a href="tel:+01321654214">+01 321 654 214</a></li>
                        <li><i class='bx bx-envelope'></i> Email Us: <a href="mailto:hello@qovid.com">hello@qovid.com</a></li>
                        <li><i class='bx bx-microphone'></i> Fax: <a href="tel:+123456789">+123456789</a></li>
                    </ul>

                    <h3>Opening Hours:</h3>
                    <ul class="opening-hours">
                        <li><span>Monday:</span> 8AM - 6AM</li>
                        <li><span>Tuesday:</span> 8AM - 6AM</li>
                        <li><span>Wednesday:</span> 8AM - 6AM</li>
                        <li><span>Thursday - Friday:</span> 8AM - 6AM</li>
                        <li><span>Sunday:</span> Closed</li>
                    </ul>

                    <h3>Follow Us:</h3>
                    <ul class="social">
                        <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-skype'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-pinterest-alt'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-youtube'></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="emergency-contact-area pb-100">
    <div class="container">
        <div class="emergency-contact-inner">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-12">
                    <div class="btn-box">
                        <a routerLink="/" class="default-btn"><i class="flaticon-open-book"></i> Solicita una cita</a>
                        <a routerLink="/" class="default-btn"><i class="flaticon-doctor"></i> Meet The Doctor</a>
                    </div>
                </div>

                <div class="col-lg-4 col-md-12">
                    <div class="contact-cta">
                        <a href="tel:+595971372209">
                            <i class="flaticon-call"></i>
                            <span>Emergency Contact</span>
                            +595 971 372209
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section-->
<app-header-four></app-header-four>

<section class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Contáctanos</h2>
            <ul>
                <li><a routerLink="/">Inicio</a></li>
                <li>Contacto</li>
            </ul>
        </div>
    </div>
</section>

<div class="col-lg-7 col-md-12">
                <div class="contact-form">
                    <h3>Envíanos un mensaje</h3>
                    <p>
                        Estamos disponibles para responder tus consultas, recibir sugerencias o coordinar acciones solidarias. 
                        Completá el formulario y nos pondremos en contacto contigo a la brevedad.
                    </p>

                </div>
            </div>
<form id="contactForm" (ngSubmit)="enviar()" #contactForm="ngForm">
    
  <div class="row">
    <div class="col-lg-12">
      <div class="form-group">
        <label>Nombre <span>*</span></label>
        <input type="text" name="name" [(ngModel)]="form.name" required class="form-control" placeholder="Tu nombre">
      </div>
    </div>

    <div class="col-lg-12">
      <div class="form-group">
        <label>Correo electrónico <span>*</span></label>
        <input type="email" name="email" [(ngModel)]="form.email" required class="form-control" placeholder="Tu correo electrónico">
      </div>
    </div>

    <div class="col-lg-12">
      <div class="form-group">
        <label>Teléfono <span>*</span></label>
        <input type="text" name="phone" [(ngModel)]="form.phone" required class="form-control" placeholder="Tu número de contacto">
      </div>
    </div>

    <div class="col-lg-12">
      <div class="form-group">
        <label>Mensaje <span>*</span></label>
        <textarea name="message" [(ngModel)]="form.message" required cols="30" rows="5" class="form-control" placeholder="Escribe tu mensaje..."></textarea>
      </div>
    </div>

    <div class="col-lg-12">
      <button type="submit" class="default-btn">
        <i class='flaticon-plane'></i> Enviar mensaje
      </button>
      
    </div>
  </div>
</form>


<!--section class="contact-area ptb-100">
    <div class="container">
        <div class="row">

            <div class="col-lg-5 col-md-12">
                <div class="contact-info">
                    <h3>Estamos para ayudarte</h3>
                    <p>
                        Si tenés dudas sobre nuestras actividades, proyectos o formas de colaborar, podés revisar nuestras 
                        <a routerLink="/faq">preguntas frecuentes</a> o contactarnos directamente.
                    </p>

                    <ul class="contact-list">
                        <li>
                            <i class='bx bx-map'></i> 
                            Ubicación: <a href="#">Asunción, Paraguay</a>
                        </li>
                        <li>
                            <i class='bx bx-phone-call'></i> 
                            Teléfono: <a href="tel:+595971372209">+595 971 372209</a>
                        </li>
                        <li>
                            <i class='bx bx-envelope'></i> 
                            Email: <a href="mailto:fundacion@acostanu.org">fundacion@acostanu.org</a>
                        </li>
                        <li>
                            <i class='bx bx-group'></i> 
                            Tipo: Fundación sin fines de lucro
                        </li>
                    </ul>

                    <h3>Horarios de atención:</h3>
                    <ul class="opening-hours">
                        <li><span>Lunes a Viernes:</span> 08:00 - 18:00</li>
                        <li><span>Sábados:</span> 08:00 - 12:00</li>
                        <li><span>Domingos:</span> Cerrado</li>
                    </ul>

                    <h3>Síguenos:</h3>
                    <ul class="social">
                        <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-youtube'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="emergency-contact-area pb-100">
    <div class="container">
        <div class="emergency-contact-inner">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-12">
                    <div class="btn-box">
                        <a routerLink="/donaciones" class="default-btn">
                            <i class="flaticon-open-book"></i> Realizar donación
                        </a>
                        <a routerLink="/voluntariado" class="default-btn">
                            <i class="flaticon-doctor"></i> Ser voluntario
                        </a>
                    </div>
                </div>

                <div class="col-lg-4 col-md-12">
                    <div class="contact-cta">
                        <a href="tel:+595971372209">
                            <i class="flaticon-call"></i>
                            <span>Contacto directo</span>
                            +595 971 372209
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section-->